// DashSparkline — SVG polyline sparkline with circles
// Extracted from AdminIATab.tsx

import { C } from './dashboardStyles';

interface DashSparklineProps {
  points: number[];
  color?: string;
  height?: number;
  activeIdx?: number;
  onPointClick?: (idx: number) => void;
}

export function DashSparkline({
  points,
  color = C.azul2,
  height = 36,
  activeIdx,
  onPointClick,
}: DashSparklineProps) {
  if (points.length < 2) return null;
  const max = Math.max(...points, 1);
  const w = 100 / (points.length - 1);
  return (
    <svg viewBox={`0 0 100 ${height}`} width="100%" height={height} style={{ display: 'block' }}>
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="1.2"
        strokeLinejoin="round"
        points={points.map((v, i) => `${i * w},${height - 4 - (v / max) * (height - 8)}`).join(' ')}
      />
      {points.map((v, i) => {
        const isActive = activeIdx === i;
        return (
          <circle
            key={i}
            cx={i * w}
            cy={height - 4 - (v / max) * (height - 8)}
            r={isActive ? 4 : 2}
            fill={color}
            stroke={isActive ? C.azul2 : 'none'}
            strokeWidth={isActive ? 1.5 : 0}
            style={{ cursor: onPointClick ? 'pointer' : 'default', transition: 'all 0.2s ease' }}
            onClick={() => onPointClick?.(i)}
          />
        );
      })}
    </svg>
  );
}
